import type { DashboardViewState, WidgetRequestCause, WidgetRequestIntent } from './state'

export function createWidgetRequestIntent(
  state: DashboardViewState,
  widgetId: string,
  cause: WidgetRequestCause,
): WidgetRequestIntent | null {
  const session = state.widgets[widgetId]
  if (!session) return null

  return {
    widgetId,
    cause,
    query: {
      ...session.query,
      drilldown: session.query.drilldown
        ? { ...session.query.drilldown }
        : null,
    },
    appliedFilters: {
      slicerValues: { ...state.appliedFilters.slicerValues },
      dateRange: { ...state.appliedFilters.dateRange },
    },
  }
}

export function createWidgetIntentKey(intent: WidgetRequestIntent) {
  return JSON.stringify({
    widgetId: intent.widgetId,
    cause: intent.cause,
    appliedFilters: intent.appliedFilters,
    page: intent.query.page,
    pageSize: intent.query.pageSize,
    sortColumn: intent.query.sortColumn,
    sortDirection: intent.query.sortDirection,
    groupByDimension: intent.query.groupByDimension,
    groupByDimensions: intent.query.groupByDimensions,
    measureParameterSelections: intent.query.measureParameterSelections ?? null,
    drilldown: intent.query.drilldown
      ? `${intent.query.drilldown.field}|${intent.query.drilldown.value}|${intent.query.drilldown.dimension}`
      : null,
  })
}
